import {makeStyles} from '@material-ui/core/styles';
import React from "react";
import clsx from 'clsx';

const useStyles = makeStyles(theme => ({
    root: {
        width: '100%',
    }
}));

export default function ExchangeText({className, ...props}) {
    const classes = useStyles();

    return (
        <p
            className={clsx(classes.root, className)}
            {...props}
        >
            {props.children}
        </p>
    );
};